module.exports = __webpack_public_path__ + "media/images/search_icon01-7791cf3b37949cfad3a99016f2c8c6da.svg";